import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM DEBUG files
 * 
 * Handles debug measurements including:
 * - CLOCK_TICKS (system clock ticks)
 * - DBG_FLOAT1-7 (debug float values)
 * - RPM (rotation rate)
 * - TEMPERATURE_C (temperature in Celsius)
 */
export class SmartDmDebugParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'CLOCK_TICKS': 'ticks',
      'DBG_FLOAT1': 'debug',
      'RPM': 'RPM',
      'DBG_FLOAT2': 'debug',
      'DBG_FLOAT3': 'debug',
      'DBG_FLOAT4': 'debug',
      'DBG_FLOAT5': 'debug',
      'DBG_FLOAT6': 'debug',
      'TEMPERATURE_C': '°C',
      'DBG_FLOAT7': 'debug'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'DEBUG',
      'JAE_SMARTDM_DEBUG',
      unitMappings
    );
  }
} 